import React from "react";
import TextField from "@mui/material/TextField";
import "./styles.scss";

type AmountFieldPropTypes = {
  amount: string;
  setAmount: Function;
  [key: string]: any;
};
const AmountInputField = (props: AmountFieldPropTypes) => {
  const { amount, setAmount, ...restProps } = props;

  const handleBlur = (event: { target: { value: string } }) => {
    const inputValue = parseFloat(event.target.value).toFixed(2);
    setAmount(isNaN(parseFloat(event.target.value)) ? "" : inputValue.toString());
  };

  const handleChange = (event: { target: { value: any } }) => {
    const inputValue = event.target.value;
    if (/^\d*\.?\d{0,2}$/.test(inputValue) || inputValue === "") {
      setAmount(inputValue);
    }
  };

  return (
    <TextField
      label="Amount"
      value={amount === '0' ? '' : amount}
      className="amount-outlined-input"
      onChange={handleChange}
      placeholder="0.00"
      onBlur={handleBlur}
      variant="outlined"
      InputProps={{
        startAdornment: "$",
      }}
      {...restProps}
      size="small"
    />
  );
};

export default AmountInputField;
